import React, { useState } from "react";
import styled from "styled-components";
import { DateRangePicker } from "rsuite";
import { predefinedBottomRanges } from "../../../assets/data";
import { MdClear } from "react-icons/md";

const ReportCard = (props) => {
    //console.log(props)
    return (
<CardContainer className='justify-center w-auto max-h-80 m-5 h-full'>
                        <LightCard className=" h-auto m-5 p-4 w-full justify-center">
                            {/* Date Range Filter */}
                            <FilterSection>
                                <FilterLabel>Filter by Date Range:</FilterLabel>
                                <DateRangeWrapper>
                                    <StyledDateRange
                                        id="reportsDateRange"
                                        value={props.dateRange || []}
                                        ranges={predefinedBottomRanges}
                                        placeholder="Select Date Range"
                                        format="yyyy-MM-dd"
                                        cleanable
                                        onChange={props.handleDateRangeChange}
                                    />
                                    {props.dateRange && props.dateRange.length === 2 && (
                                        <ClearButton onClick={props.handleClearDateRange} title="Clear date range">
                                            <MdClear />
                                        </ClearButton>
                                    )}
                                </DateRangeWrapper>
                                {props.dateRange && props.dateRange.length === 2 && props.dateRange[0] && props.dateRange[1] && (
                                    <DateRangeDisplay>
                                        {props.dateRange[0].toLocaleDateString("en-US")} - {props.dateRange[1].toLocaleDateString("en-US")}
                                    </DateRangeDisplay>
                                )}
                            </FilterSection>

                            <LightCardLabel className="text-ikura">TOTAL SALVATIONS / RE-DEDICATIONS</LightCardLabel>
                            <LightCardValue className="text-[#FF7234]">
                           {props.totals.Salvation_count}
                            </LightCardValue>
                            <LightCardLabel className="text-[#FF7234]">CONFIRMED SALVATIONS</LightCardLabel>
                        
                            <LightCardValue className="text-[#CF6537]">
                            {props.totals.Rededication_count}
                            </LightCardValue>
                            <LightCardLabel className="text-[#CF6537]">CONFIRMED RE-DEDICATIONS</LightCardLabel>
                            <LightCardValue className="text-[#CF3748]">
                            {props.totals.Prayer_count}
                            </LightCardValue>
                            <LightCardLabel className="text-[#CF3748]">CONFIRMED GENERAL PRAYERS</LightCardLabel>
                        </LightCard>
                    </CardContainer>
    )
};
export default ReportCard;

const CardContainer = styled.div`
    display:flex;
`;
const LightCard = styled.div`
    display: flex;
    flex-direction: column;
    
    background-color: white;
    box-shadow: 10px 10px 5px whitesmoke;
    border-radius: 30px;
    
`;
const LightCardValue = styled.div`
   
text-align: center;
font-family: Recoleta;
font-size: 50px;
font-style: normal;
font-weight: 900;
line-height: normal;
`;

const LightCardLabel = styled.div`
 text-align: center;
font-family: "Space Grotesk";
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: normal;
letter-spacing: 3.5px;

`;

const FilterSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #e0e0e0;
`;

const FilterLabel = styled.label`
    font-family: "Space Grotesk";
    font-size: 12px;
    font-weight: 600;
    color: #00323b;
    letter-spacing: 2px;
`;

const DateRangeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const StyledDateRange = styled(DateRangePicker)`
    flex: 1;
    width: 100%;
`;

const ClearButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    background-color: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    color: #666;
    transition: all 0.2s;
    flex-shrink: 0;

    &:hover {
        background-color: #e0e0e0;
        color: #333;
    }

    svg {
        font-size: 16px;
    }
`;

const DateRangeDisplay = styled.div`
    font-family: "Futura PT";
    font-size: 12px;
    color: #106271;
    padding: 6px 10px;
    background-color: #f4f8fe;
    border-radius: 4px;
    border: 1px solid #106271;
    text-align: center;
`;